import * as React from 'react';
import './styles.scss';
import { forwardRef, useState, HTMLProps } from 'react';
import { Button } from '../button/button';

export type HoverButtonProps = HTMLProps<HTMLButtonElement> & {
  buttonType?: 'button' | 'link' | undefined;
  hoverChildren?: React.ReactNode;
};


export const HoverButton = forwardRef<HTMLButtonElement, HoverButtonProps>(
  (props, buttonRef) => {
    const [buttonChildren, setButtonChildren] = useState(props.children);
    const [hoverClass, setHoverClass] = useState("");

    const onHover = (isHover: boolean) => {
      setButtonChildren(isHover ? props.hoverChildren : props.children);
      setHoverClass(isHover ? "cmp-hover-button__hover" : "");
    }

    const baseButtonProps = {
      buttonType: props.buttonType,
      className: props.className + ' cmp-hover-button__hover-element',
      onMouseOver: () => onHover(true),
      onMouseOut: () => onHover(false),
      'aria-hidden': true,
      taborder: -1
    }

    return (
      <span className="cmp-hover-button-container">
        <Button {...baseButtonProps} onClick={props.onClick} ref={React.createRef()}>{props.children}</Button>{/* need this hidden button for hover text changes to function correctly */}
        <Button buttonType={props.buttonType} className={`cmp-hover-button__button ${props.className} ${hoverClass}`} ref={buttonRef}>{buttonChildren}</Button>
      </span>
    )

  }
);
